import { defineMessages } from 'react-intl';

export const toolbarMessages: {
	singleColumn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	twoColumns: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	singleColumnAdvancedLayout: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	twoColumnsAdvancedLayout: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	threeColumns: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	threeColumnsAdvancedLayout: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fourColumns: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fiveColumns: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rightSidebar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	leftSidebar: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	threeColumnsWithSidebars: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	threeColumnsWithLeftSidebars: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	threeColumnsWithRightSidebars: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	floatingToolbarRadioGroupAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	layoutPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	controlslayoutPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnOption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resizeLayout: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	singleColumn: {
		id: 'fabric.editor.single',
		defaultMessage: 'Single column layout',
		description:
			'The text is shown as a label on a toolbar button when the user selects a single column layout option in the editor.',
	},
	twoColumns: {
		id: 'fabric.editor.twoColumns',
		defaultMessage: 'Two columns layout',
		description:
			'Label for the toolbar button that applies a two equal-width columns layout to the selected content.',
	},
	singleColumnAdvancedLayout: {
		id: 'fabric.editor.singleColumns',
		defaultMessage: '1 Column layout',
		description:
			'Label for the toolbar button that applies a single-column layout to the selected content in the advanced layout options.',
	},
	twoColumnsAdvancedLayout: {
		id: 'fabric.editor.twoColumns',
		defaultMessage: '2 Column layout',
		description:
			'Label for the advanced layout toolbar button that applies a two equal-width columns layout.',
	},
	threeColumns: {
		id: 'fabric.editor.threeColumns',
		defaultMessage: 'Three columns layout',
		description: 'Layout with three columns of equal width',
	},
	threeColumnsAdvancedLayout: {
		id: 'fabric.editor.threeColumns',
		defaultMessage: '3 Column layout',
		description: 'Layout with three columns of equal width',
	},
	fourColumns: {
		id: 'fabric.editor.fourColumns',
		defaultMessage: '4 Column layout',
		description:
			'Label for the advanced layout toolbar button that applies a four equal-width columns layout.',
	},
	fiveColumns: {
		id: 'fabric.editor.fiveColumns',
		defaultMessage: '5 Column layout',
		description:
			'Label for the advanced layout toolbar button that applies a five equal-width columns layout.',
	},
	rightSidebar: {
		id: 'fabric.editor.rightSidebar',
		defaultMessage: 'Right sidebar layout',
		description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page',
	},
	leftSidebar: {
		id: 'fabric.editor.leftSidebar',
		defaultMessage: 'Left sidebar layout',
		description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page',
	},
	threeColumnsWithSidebars: {
		id: 'fabric.editor.threeColumnsWithSidebars',
		defaultMessage: 'Three columns with sidebars layout',
		description: 'Layout with 3 columns laid out as 25% - 50% - 25%',
	},
	threeColumnsWithLeftSidebars: {
		id: 'fabric.editor.threeColumnsWithLeftSidebars',
		defaultMessage: 'Three columns with left sidebar layout',
		description: 'Layout with 3 columns laid out as 25% - 25% - 50%',
	},
	threeColumnsWithRightSidebars: {
		id: 'fabric.editor.threeColumnsWithRightSidebars',
		defaultMessage: 'Three columns with right sidebar layout',
		description: 'Layout with 3 columns laid out as 50% - 25% - 25%',
	},
	floatingToolbarRadioGroupAriaLabel: {
		id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
		defaultMessage: 'Layout options',
		description: "a floating toolbar radiogroup's aria label",
	},
	layoutPlaceholder: {
		id: 'fabric.editor.layout.placeholder',
		defaultMessage: 'Add content',
		description:
			'Placeholder text shown inside an empty layout column, prompting the user to add content.',
	},
	controlslayoutPlaceholder: {
		id: 'fabric.editor.layout.controls.placeholder',
		defaultMessage: '/ to insert',
		description:
			'Placeholder text shown inside an empty layout column when controls are active, instructing the user to type / to open the insert menu.',
	},
	columnOption: {
		id: 'fabric.editor.layout.columnOption',
		defaultMessage: '{count, plural, one {{count} Column} other {{count} Columns}}',
		description:
			'The text is shown as a label for a layout column option in the editor toolbar. It displays the number of columns, for example "1 Column" or "3 Columns".',
	},
	resizeLayout: {
		id: 'fabric.editor.layout.resizeLayout',
		defaultMessage: 'Resize layout',
		description:
			'The text is shown as a label on a button or handle when the user can resize the layout columns in the editor.',
	},
});
